// import Vue from 'vue'
// import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
        path: '/',
        redirect: {
            name: "broadcast"
        }
    },
    {
        path: '/broadcast',
        name: 'broadcast',
        component: () =>
            import ('@/components/information/broadcast.vue'),
    },
    {
        path: '/financing',
        name: 'financing',
        component: () =>
            import ('@/components/information/financing.vue'),
    },
    {
        path: '/drygoods',
        name: 'drygoods',
        component: () =>
            import ('@/components/information/drygoods.vue'),
    },
    {
        path: '/project',
        name: 'project',
        component: () =>
            import ('@/components/information/project.vue'),
    },
    {
        path: '/comments',
        name: 'comments',
        component: () =>
            import ('@/components/information/comments.vue'),
    },
    {
        path: '/interview',
        name: 'interview',
        component: () =>
            import ('@/components/information/interview.vue'),
    },
    {
        path: '/weekly',
        name: 'weekly',
        component: () =>
            import ('@/components/information/weekly.vue'),
    },
    {
        path: '/monthly',
        name: 'monthly',
        component: () =>
            import ('@/components/information/monthly.vue'),
    },
    {
        path: '/report',
        name: 'report',
        component: () =>
            import ('@/components/research/report.vue'),
    },
    {
        path: '/list',
        name: 'list',
        component: () =>
            import ('@/components/research/list.vue'),
    },
    {
        path: '/evaluation',
        name: 'evaluation',
        component: () =>
            import ('@/components/research/evaluation.vue'),
    },
    {
        path: '/Nretail',
        name: 'Nretail',
        component: () =>
            import ('@/components/data/Nretail.vue'),
    },
    {
        path: '/Scommerce',
        name: 'Scommerce',
        component: () =>
            import ('@/components/data/Scommerce.vue'),
    },
    {
        path: '/financeData',
        name: 'financeData',
        component: () =>
            import ('@/components/data/financeData.vue'),
    },
    {
        path: '/RuralMORE',
        name: 'RuralMORE',
        component: () =>
            import ('@/components/data/RuralMORE.vue'),
    },
    {
        path: '/FarmTable',
        name: 'FarmTable',
        component: () =>
            import ('@/components/data/FarmTable.vue'),
    },
    {
        path: '/Mbaby',
        name: 'Mbaby',
        component: () =>
            import ('@/components/data/Mbaby.vue'),
    },
    {
        path: '/Luxury',
        name: 'Luxury',
        component: () =>
            import ('@/components/data/Luxury.vue'),
    },
    {
        path: '/Used',
        name: 'Used',
        component: () =>
            import ('@/components/data/Used.vue'),
    },
    {
        path: '/Automobile',
        name: 'Automobile',
        component: () =>
            import ('@/components/data/Automobile.vue'),
    },
    {
        path: '/Cgroup',
        name: 'Cgroup',
        component: () =>
            import ('@/components/data/Cgroup.vue'),
    },
    {
        path: '/Medicine',
        name: 'Medicine',
        component: () =>
            import ('@/components/data/Medicine.vue'),
    },
    {
        path: '/SaaS',
        name: 'SaaS',
        component: () =>
            import ('@/components/data/SaaS.vue'),
    },
    {
        path: '/Clothing',
        name: 'Clothing',
        component: () =>
            import ('@/components/data/Clothing.vue'),
    },
    {
        path: '/Live',
        name: 'Live',
        component: () =>
            import ('@/components/data/Live.vue'),
    },
    {
        path: '/complainList',
        name: 'complainList',
        component: () =>
            import ('@/components/complaints/complainList.vue'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

export default router